import PropTypes from 'prop-types';
import React from 'react';

import IfmsButton, { IfmsButtonProps } from './IfmsButton';

const SecondaryButton = React.forwardRef<HTMLButtonElement, IfmsButtonProps>(({children, ...other}, ref) => {
  const name = !other.name ? `secondary-btn-${children}` : other.name;
  //const baseClass = !other.notsetbackcolorwhenfocus ? 'ifms-secondary-button' : 'ifms-secondary-button b';

  let baseClass = 'ifms-secondary-button';

  if (other.notsetbackcolorwhenfocus === 'b') {
      baseClass = 'ifms-secondary-button b';
  } else if (other.notsetbackcolorwhenfocus === 'gray') {
      baseClass = 'ifms-secondary-button gray';
  } else if (other.notsetbackcolorwhenfocus === 'cnttrack') {
      baseClass = 'ifms-secondary-button cnttrack';
  } else if(other.notsetbackcolorwhenfocus === 'clear'){
      baseClass = 'ifms-secondary-button clear';
  }else {
      baseClass = 'ifms-secondary-button';
  }

  return (
    <IfmsButton ref={ref} {...other} baseClass={baseClass}  name={name}>
      {children}
    </IfmsButton>
  );
});

SecondaryButton.defaultProps = {
  bold : false
};

SecondaryButton.propTypes = {
  size: PropTypes.oneOf(['regular', 'small', 'large', 'extrasmall']),
  bold: PropTypes.bool
};

export default React.memo(SecondaryButton);

